module.exports = __webpack_public_path__ + "static/media/flc_paynow_qrcode.9efde71d.jpg";